<template lang="pug">
  .chips.chips--inline
    v-chip(outlined color='primary' close close-icon="mdi-close"
      v-if="model.filters.search"
      @click:close="removeFilter({field: 'search'})"
    ).chip-common.chip-common--small
      .overflow-text Search: {{ model.filters.search }}
    v-chip(outlined color='primary' close close-icon="mdi-close"
      v-if="model.filters.examLocation"
      @click:close="removeFilter({field: 'examLocation'})"
    ).chip-common Exam date to: {{ model.filters.examLocation }}
    v-chip(outlined color='primary' close close-icon="mdi-close"
      v-if="model.filters.examDateAfter"
      @click:close="removeFilter({field: 'examDateAfter'})"
    ).chip-common Exam date from: {{ model.filters.examDateAfter | formattedDate }}  
    v-chip(outlined color='primary' close close-icon="mdi-close"
      v-if="model.filters.examDateBefore"
      @click:close="removeFilter({field: 'examDateBefore'})"
    ).chip-common Exam date to: {{ model.filters.examDateBefore | formattedDate }}
</template>

<script>

export default {
  props: {
    model: {
      type: Object,
      required: true
    },
    activeCourse: Object
  },
  
  methods: {
    removeFilter({field}) {
      this.$emit('remove', field)
    }
  },
}
</script>

<style lang="scss">
  .chips--inline {
    display: inline;
  }
  .chip-common {
    margin-bottom: 16px;
    font-weight: bold;
    &:not(:last-child) {
      margin-right: 8px;
    }

   &--small {
     max-width: 250px;
   }
  }
</style>
